import { StyleSheet, ViewPropTypes, Easing } from 'react-native';
import PropTypes from 'prop-types';
import R from '../../core-res/R';
const TRACK_SIZE = 2;
const THUMB_SIZE = 32;
export const styles = StyleSheet.create({
    container: {
        height: 40,
        justifyContent: 'center',
    },
    track: {
        height: TRACK_SIZE,
        borderRadius: TRACK_SIZE / 2,
    },
    thumb: Object.assign({ position: 'absolute', width: THUMB_SIZE, height: THUMB_SIZE, borderRadius: THUMB_SIZE / 2, borderWidth: R.border.width.thin, borderColor: R.color.uiLightSecondary }, R.elevation.raised),
    touchArea: {
        position: 'absolute',
        backgroundColor: 'transparent',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
    },
    debugThumbTouchArea: {
        position: 'absolute',
        backgroundColor: R.color.uiGreenPrimary,
        opacity: R.opacity.translucent(),
    },
});
export const propTypes = {
    value: (props, propName, componentName) => {
        if (props[propName] && typeof props[propName] !== 'number' && !Array.isArray(props[propName])) {
            return new Error(`Invalid prop ${propName} supplied to ${componentName}. This prop must be a number, or an array of numbers.`);
        }
    },
    disabled: PropTypes.bool,
    minimumValue: PropTypes.number,
    maximumValue: PropTypes.number,
    step: PropTypes.number,
    minimumTrackTintColor: PropTypes.string,
    maximumTrackTintColor: PropTypes.string,
    thumbTintColor: PropTypes.string,
    thumbTouchSize: PropTypes.shape({
        width: PropTypes.number,
        height: PropTypes.number,
    }),
    onValueChange: PropTypes.func,
    onSlidingStart: PropTypes.func,
    onSlidingComplete: PropTypes.func,
    style: PropTypes.object,
    trackStyle: ViewPropTypes.style,
    thumbStyle: ViewPropTypes.style,
    thumbImage: PropTypes.array,
    thumbView: PropTypes.array,
    debugTouchArea: PropTypes.bool,
    animateTransitions: PropTypes.bool,
    animationType: PropTypes.oneOf(['spring', 'timing']),
    animationConfig: PropTypes.object,
    trackColor: PropTypes.string,
    trackHighlightColor: PropTypes.string,
};
export const defaultProps = {
    value: 0,
    minimumValue: 0,
    maximumValue: 100,
    step: 1,
    trackHighlightColor: '#3f3f3f',
    trackColor: '#b3b3b3',
    thumbTintColor: R.color.uiLightPrimary,
    thumbTouchSize: { width: 48, height: 48 },
    debugTouchArea: false,
    animationType: 'timing',
};
export const DEFAULT_ANIMATION_CONFIGS = {
    spring: {
        friction: 7,
        tension: 100,
    },
    timing: {
        duration: 150,
        easing: Easing.inOut(Easing.ease),
        delay: 0,
    },
};
export function Rect(x, y, width, height) {
    this.x = x;
    this.y = y;
    this.width = width;
    this.height = height;
}
Rect.prototype.containsPoint = function containsPoint(x, y) {
    return x >= this.x && y >= this.y && x <= this.x + this.width && y <= this.y + this.height;
};
